(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["FrontApp"] = factory();
	else
		root["FrontApp"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return webpackJsonp_name_([1],{

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(269);

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _FormWidgetMixin = __webpack_require__(270);

var _FormWidgetMixin2 = _interopRequireDefault(_FormWidgetMixin);

var _isNull2 = __webpack_require__(197);

var _isNull3 = _interopRequireDefault(_isNull2);

var _isUndefined2 = __webpack_require__(198);

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*import 'selectric'*/

/*import FormWidgetMixin from './core/site/forms/core/FormWidgetMixin'*/
if ((0, _isUndefined3.default)(window._)) {
  window._ = {
    isUndefined: _isUndefined3.default,
    isNull: _isNull3.default
  };
} // module.exports = require('./core/_front')


if (!window.BackApp) {
  window.Vue = __webpack_require__(199);
  var Resource = __webpack_require__(34);
  Vue.use(Resource);
}

Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('value');

var frontForm = function frontForm(pWidgetId, elementId, pModel) {
  if (!document.getElementById(elementId)) return new Vue();

  return new Vue({
    el: '#' + elementId,
    mixins: [_FormWidgetMixin2.default],
    data: {
      elementId: elementId,
      model: pModel,
      widgetId: pWidgetId
    },
    watch: {
      showMessage: function showMessage(val, oldVal) {
        if (!val) return;

        // <input id="{{'thx-page-' . $elementId}}" type="hidden" value="{{ page_url('thanks')}}"/>
        var url = document.querySelector('#thx-page-' + elementId);
        if (url === null) url = document.querySelector('#thx-page' + elementId);

        if (url === null || (url = url.getAttribute('value')) === null) return;

        window.location = url;
      }
    }
    /*
     ready(){
      let that = this;
     if (this.elementId == 'contact-form') {
      Vue.nextTick(() => {
     $('.selecter')
     .selectric({maxHeight: 250, disableOnMobile: false})
     .on('change', function (element) {
     that.model.options = $(this).val()
     });
     $('.selectric').find('.button').html('<span class="c-ab arrow_down_icon xsprite">&nbsp;</span>')
       if (this.getParameterByName('options')) {
     this.model.options = this.getParameterByName('options')
     $('.selecter').val(this.model.options).selectric('refresh')
     }//endif
      if (this.getParameterByName('subject'))
     this.model.subject = this.getParameterByName('subject')
      })
      }//endif
     }
     */
  });
};

var FrontApp = {
  frontForm: frontForm,
  getAssets: function getAssets(record, table, field, assets) {
    var index = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    if (record[table] === undefined || record[table][field] === undefined || record[table][field]['assets'] === undefined) return false;

    if (index !== null) return record[table][field]['assets'][index] !== undefined && assets[record[table][field]['assets'][index]] !== undefined ? assets[record[table][field]['assets'][index]] : false;

    var list = [];
    for (var id in record[table][field]['assets']) {
      if (assets[id] !== undefined) list.push(assets[id]);
    }return list;
  }
};

module.exports = FrontApp;

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _FormWidgetSubmitService = __webpack_require__(271);

var _FormWidgetSubmitService2 = _interopRequireDefault(_FormWidgetSubmitService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            errors: false,
            model: {},
            saved: false,
            showMessage: false,
            submitted: false,
            widgetId: 0
        };
    },

    methods: {
        checkStatus: function checkStatus(response) {
            if (response.status == 'error') {
                this.errors = response.messages.errors;

                return false;
            }

            return true;
        },
        getParameterByName: function getParameterByName(name, url) {
            if (!url) {
                url = window.location.href;
            }
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';

            return decodeURIComponent(results[2].replace(/\+/g, " "));
        },
        getService: function getService() {
            var language = _.isNull(document.querySelector('meta#language')) ? false : document.querySelector('meta#language').getAttribute('value');
            return new _FormWidgetSubmitService2.default(this.widgetId, language);
        },
        hasError: function hasError(label) {
            if (_.isUndefined(this.errors)) return false;

            if (this.errors === false) return false;

            if (_.isUndefined(this.errors[label])) return false;

            return true;
        },
        init: function init(widgetId, model) {
            this.model = model;
            this.widgetId = widgetId;
        },
        isReady: function isReady() {
            return !_.isUndefined(this.model) && widgetId > 0;
        },
        onSubmitForm: function onSubmitForm(e) {
            e.preventDefault();
            this.saved = false;
            this.errors = false;
            this.showMessage = false;

            this.store(this.model);
        },
        postStore: function postStore(response) {},
        preStore: function preStore(response) {},
        store: function store(model) {
            var _this = this;

            var service = this.getService();
            service.store(model, function (response) {

                if (!_this.checkStatus(response)) return;

                _this.preStore(response);
                _this.model = response.data.results;
                _this.saved = true;
                _this.showMessage = true;
                _this.postStore(response);
            });
        }
    }
};

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Vue from 'vue'

var FormWidgetSubmitService = function () {
    function FormWidgetSubmitService(id) {
        var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        (0, _classCallCheck3.default)(this, FormWidgetSubmitService);

        this.id = id;
        this.api = '/api/forms/' + id + '/submit';
        if (language) this.api += '?language=' + language;

        this.queryString = {};
    }

    (0, _createClass3.default)(FormWidgetSubmitService, [{
        key: 'store',
        value: function store(model, success) {
            var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;


            Vue.http.post(this.api, model).then(function (response) {
                success(response.data);
            }, function (response) {
                if (!_.isNull(error)) error(response);else console.log(response);
            });
        }
    }, {
        key: 'update',
        value: function update(id, model, success) {
            var error = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            Vue.http.put(this.api + '/' + id, model).then(function (response) {
                success(response.data);
            }, function (response) {
                if (!_.isNull(error)) error(response);else console.log(response);
            });
        }
    }]);
    return FormWidgetSubmitService;
}();

exports.default = FormWidgetSubmitService;

/***/ })

},[268]);
});


// WEBPACK FOOTER //
// public/js/ui/FrontApp.js